import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Icon } from 'antd';
import { localFilesSelector } from '../../store/selectors';
import { setLocalFiles } from '../../store/actions';
import styles from './LocalFileList.module.scss';

const LocalFileList = () => {
  const dispatch = useDispatch();
  const localFiles = useSelector(localFilesSelector);

  const handleRemoveFile = (file) => {
    const newFiles = localFiles.filter(
      (localFile) => localFile.uid !== file.uid
    );
    dispatch(setLocalFiles(newFiles));
  };

  if (localFiles.length === 0) {
    return null;
  }

  return (
    <ul className={styles.root}>
      {localFiles.map((file) => (
        <li key={file.uid} className={styles.item}>
          <p className={styles.fileName}>
            <Icon type="paper-clip" />
            {file.name}
          </p>
          <Button
            icon="delete"
            type="link"
            className={styles.removeFileBtn}
            onClick={() => handleRemoveFile(file)}
          />
        </li>
      ))}
    </ul>
  );
};

export default LocalFileList;
